import { Fragment } from 'react'
import { ShareButton } from './popups/ShareButton'
import { FormattedMessage } from 'react-intl'

export const DiveSiteHeader = ({ location = {}, diveSite }) => {
  return (
    <Fragment>
      <div className='dive-site-header__text'>{location.locationTitle}</div>
      <div className='dive-site-header__text'>
        <i className='font-icons icon-thumbs-up-new' />
        <span>
          {location.rating ? (
            `${location.rating}%`
          ) : (
            <FormattedMessage id='n_a' defaultMessage='N/A' />
          )}
        </span>
        <span>({location.reviewsAmount || 0})</span>
      </div>
      <ShareButton title={diveSite} />
    </Fragment>
  )
}
